module.exports = __webpack_public_path__ + "media/18.f7f5b7c4.mp3";